import styled from 'styled-components';

export const StyledLayout = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.darkBlack};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  height: calc(100vh - 5.5rem);
`;
